/**
 * ship-cutoff.js — site-wide ship-cutoff message updater.
 *
 * Rewrites the text of any element with [data-ship-cutoff] based on the
 * current Australia/Sydney time (DST-safe). Lifted from the per-section
 * logic in section-queen-length-v2.js so cart, announcement bar, and any
 * future surface stay in lockstep with the PDP qlv2-ship block.
 *
 * Wire-up:
 *   <span data-ship-cutoff data-ship-cutoff-format="arrow">...fallback text...</span>
 *
 * Optional attribute:
 *   data-ship-cutoff-format="arrow"  -> "Order before 1pm AEST -> ships today"   (default)
 *   data-ship-cutoff-format="comma"  -> "Order before 1pm AEST, ships today"
 *
 * Cutoff: 1pm AEST (hour < 13 in Australia/Sydney).
 *   Mon-Fri before cutoff  → ships today
 *   Mon-Thu after cutoff   → ships tomorrow
 *   Fri after cutoff       → ships Monday
 *   Sat / Sun              → ships Monday
 */
(function () {
  'use strict';

  function computeMessage(format) {
    var sep = format === 'comma' ? ', ' : ' → ';
    try {
      var parts = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Sydney',
        weekday: 'long',
        hour: 'numeric',
        hour12: false
      }).formatToParts(new Date());
      var weekday = parts.find(function (p) { return p.type === 'weekday'; }).value;
      var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
      var beforeCutoff = hour < 13;
      var weekdays = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
      var d = weekdays[weekday];

      if (d >= 1 && d <= 5 && beforeCutoff) return 'Order before 1pm AEST' + sep + 'ships today';
      if (d === 5 && !beforeCutoff)         return 'Order now' + sep + 'ships Monday';
      if (d >= 1 && d <= 4 && !beforeCutoff) return 'Order now' + sep + 'ships tomorrow';
      return 'Order now' + sep + 'ships Monday';
    } catch (e) {
      return null;
    }
  }

  function apply() {
    var els = document.querySelectorAll('[data-ship-cutoff]');
    if (!els.length) return;
    els.forEach(function (el) {
      var format = el.getAttribute('data-ship-cutoff-format') || 'arrow';
      var msg = computeMessage(format);
      if (msg && el.textContent.trim() !== msg) {
        el.textContent = msg;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('cart-updated', apply, true);
  window.acShipCutoffApply = apply;
})();
